// src/pages/Dashboard.js
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ClusterDiagram from '../components/ClusterDiagram';
import InfrastructureTable from '../components/InfrastructureTable';
import { fetchClusterData } from '../slices/clusterSlice';
import "../design/dashboard.css";
import { Breadcrumb, Result, Spin, Button } from 'antd';
import { Link } from 'react-router-dom';

const Dashboard = () => {
  const dispatch = useDispatch();
  const { data: clusterData, loading, error } = useSelector(state => state.cluster);

  useEffect(() => {
    dispatch(fetchClusterData());
  }, [dispatch]);

  let content;

  if (loading === 'pending') {
    content = (
      <div className="dashboard-center">
        <Spin size="large" />
        <p className="dashboard-loading-text">Loading infrastructure details…</p>
      </div>
    );
  } else if (loading === 'failed') {
    content = (
      <div className="dashboard-center">
        <Result
          status="error"
          title="Could not load infrastructure details"
          subTitle={
            <>
              We were unable to retrieve the hardware topology from the testbed.
              <br />
              This may mean the testbed is offline or the connection is misconfigured.
            </>
          }
          extra={
            <Button type="primary" onClick={() => dispatch(fetchClusterData())}>
              Retry
            </Button>
          }
        >
          {error && (
            <div className="error-details">
              <span style={{ fontSize: 12, opacity: 0.7 }}>
                Technical details: {String(error)}
              </span>
            </div>
          )}
        </Result>
      </div>
    );
  } else if (!clusterData) {
    // No data yet but not "failed" → soft empty state
    content = (
      <div className="dashboard-center">
        <Result
          status="info"
          title="No infrastructure data available yet"
          subTitle="Once the testbed reports its nodes, the infrastructure table and diagram will appear here."
        />
      </div>
    );
  } else {
    // Normal state
    content = (
      <div className="dashboard-container">
        <div className="table-section">
          <InfrastructureTable data={clusterData} />
        </div>
        <div className="diagram-section">
          <ClusterDiagram data={clusterData} />
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="page-header">
        <div className="page-breadcrumb-wrapper">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/home">Home</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/monitoring-manager">Monitoring Manager</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Infrastructure Details</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {content}
    </>
  );
};

export default Dashboard;
